/**
 * Browser download helper, ported from loader-export.js _downloadFile: a Blob,
 * an object URL on a hidden anchor, click, and the URL revoked 5 s later.
 */

export function downloadBlob(content: string | Uint8Array<ArrayBuffer>, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** YYYY-MM-DD (UTC) for file names, as the original's toISOString().split('T')[0]. */
export function dateStamp(nowMs: number = Date.now()): string {
  return new Date(nowMs).toISOString().split('T')[0];
}
